document.addEventListener("DOMContentLoaded", function () {
    const products = window.products || [];
    const notificationContainer = document.getElementById('sales-notifications');

    if (!products.length) return;

    // Categorize products for prioritization
    const prioritizedCollections = ['booties', 'boobas', 'full size dolls'];
    const prioritizedProducts = products.filter(product =>
        prioritizedCollections.includes(product.collection)
    );
    const otherProducts = products.filter(product =>
        !prioritizedCollections.includes(product.collection)
    );

    // List of countries with weighted randomness
    const countries = [
        { name: 'USA', weight: 65 },
        { name: 'Germany', weight: 15 },
        { name: 'UK', weight: 4 },
        { name: 'Japan', weight: 4 },
        { name: 'Spain', weight: 3 },
        { name: 'Italy', weight: 2 },
        { name: 'France', weight: 2 },
        // Remaining EU countries with 1% weight
        { name: 'Austria', weight: 1 },
        { name: 'Belgium', weight: 1 },
        { name: 'Bulgaria', weight: 1 },
        { name: 'Croatia', weight: 1 },
        { name: 'Cyprus', weight: 1 },
        { name: 'Czech Republic', weight: 1 },
        { name: 'Denmark', weight: 1 },
        { name: 'Estonia', weight: 1 },
        { name: 'Finland', weight: 1 },
        { name: 'Greece', weight: 1 },
        { name: 'Hungary', weight: 1 },
        { name: 'Ireland', weight: 1 },
        { name: 'Latvia', weight: 1 },
        { name: 'Lithuania', weight: 1 },
        { name: 'Luxembourg', weight: 1 },
        { name: 'Malta', weight: 1 },
        { name: 'Netherlands', weight: 1 },
        { name: 'Poland', weight: 1 },
        { name: 'Portugal', weight: 1 },
        { name: 'Romania', weight: 1 },
        { name: 'Slovakia', weight: 1 },
        { name: 'Slovenia', weight: 1 },
        { name: 'Sweden', weight: 1 },
    ];

    // Helper function to pick a weighted random country
    function getRandomCountry() {
        const totalWeight = countries.reduce((sum, country) => sum + country.weight, 0);
        const random = Math.random() * totalWeight;
        let cumulativeWeight = 0;

        for (const country of countries) {
            cumulativeWeight += country.weight;
            if (random < cumulativeWeight) {
                return country.name;
            }
        }
    }

    // Helper function to pick a random product with prioritization
    function getRandomProduct() {
        const isPrioritized = Math.random() < 0.9; // 90% chance for prioritized products
        const productList = isPrioritized ? prioritizedProducts : otherProducts;

        if (!productList.length) return null;
        return productList[Math.floor(Math.random() * productList.length)];
    }

    function showNotification() {
        const product = getRandomProduct();
        if (!product) return;

        // Clear the container before adding a new notification
        notificationContainer.innerHTML = '';

        // Get a random country
        const country = getRandomCountry();

        // Create the notification element
        const notification = document.createElement('div');
        notification.className = 'blink-animation'; // Add blinking animation
        notification.style.cssText = `
            background: #fff; padding: 10px; margin: 5px; border: 1px solid #ddd;
            box-shadow: 0 2px 5px rgba(0,0,0,0.2); border-radius: 5px;
            display: flex; flex-direction: column; gap: 5px; position: relative;
        `;
        notification.innerHTML = `
            <div style="display: flex; align-items: center; gap: 10px;">
                <img src="${product.image}" alt="${product.name}" style="width: 50px; height: 50px;">
                <div>
                    <p style="font-weight: bold; color: #333;">
                        A customer from ${country} just bought ${product.name}
                    </p>
                </div>
            </div>
            <p style="font-size: 10px; font-style: italic; color: #aaa; text-align: right;">Verified by CareCart</p>
        `;

        // Append the notification to the container
        notificationContainer.appendChild(notification);

        // Remove the notification after 4 seconds
        setTimeout(() => {
            notificationContainer.innerHTML = '';
        }, 2000); // Display for 4 seconds
    }

    // Show notifications every 10 seconds (4 seconds visible + 6 seconds gap)
    setInterval(showNotification, 10000);

    // Show the first notification immediately
    showNotification();
});
